export const AUTHENTICATED = '/user';
export const DASHBOARD = '/dashboard';
export const LANDING = '/';
export const LOGIN = '/login';
export const RESET_PASSWORD = '/reset-password';
export const POLICIES = '/policies';
export const MAINTENANCE_REQUEST = '/maintenance-request';
export const REQUEST_DETAILS = '/request-details/:requestDocId';
export const CONTACT = '/contact';
